// @flow
import { format } from "date-fns";

export const getBaseUrl = (url: string): string =>
  url.replace(/(http(s)?:\/\/)|(\/.*){1}/g, "");

export const prettyDate = (date: string): string => {
  if (date) {
    return format(date, "MMMM D, YYYY");
  }
  return "n/a";
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js